import React from "react";
import { Diamond } from "lucide-react";

const ITEMS = [
  "BROCHURA", "CAPA DURA", "GRAMPO", "IMPRESSÃO SOB DEMANDA", "HOT STAMPING",
  "LAMINAÇÃO SOFT TOUCH", "TIRAGEM A PARTIR DE 1 UNIDADE", "WIRE-O", "VERNIZ LOCALIZADO", "PRAZO EXPRESS 2–5 DIAS",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="border-y border-neutral-900/10 bg-neutral-900 text-[#F8F7F4] py-4 overflow-hidden select-none" data-testid="editorial-marquee" aria-hidden="true">
      <div className="marquee-track items-center gap-10 pr-10 pl-mobile-static-marquee">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10 whitespace-nowrap">
            <span className={`text-sm font-bold tracking-[0.22em] ${i % 2 ? "font-garamond italic normal-case text-base tracking-normal text-neutral-300" : ""}`}>{item}</span>
            <Diamond size={9} className="text-blue-500 fill-blue-500" />
          </span>
        ))}
      </div>
    </div>
  );
}
